import { createContext, useContext, type ReactNode } from 'react';

/**
 * Carries the id of the block currently being rendered. Used by the
 * `<EditableText>` primitive to call `onPatchField(blockId, path, value)`
 * without each block component having to thread its id manually through
 * its props or shared sub-components.
 *
 * Exposed only from inside `<PageRenderer>` (admin and public alike).
 * Outside `PageRenderer` the context is `null` and editable primitives
 * fall back to a static span.
 */
const BlockIdContext = createContext<string | null>(null);

export function BlockIdProvider({ blockId, children }: { blockId: string; children: ReactNode }) {
  return <BlockIdContext.Provider value={blockId}>{children}</BlockIdContext.Provider>;
}

export function useBlockId(): string | null {
  return useContext(BlockIdContext);
}
